import React, { useState, useEffect } from "react";
import SingleMsg from "./SingleMsg";
import GroupMsg from "./Group";
import CSVMsg from "./CSV";
import { HiChevronRight } from "react-icons/hi";
import { useLocation } from "react-router-dom";

export default function MessageIndex() {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("Single MSG");
  const tabs = ["Single MSG", "Group", "CSV"];
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const tabParam = urlParams.get("tab");

    if (tabParam && tabs.includes(tabParam)) {
      setActiveTab(tabParam);
    } else if (tabParam === "Group") {
      setActiveTab("Group");
    }
  }, [location.search]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      className="bg-[#F4F5F7] p-6"
      style={{ fontFamily: "Montserrat, sans-serif" }}
    >
      {/* Page Header */}
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-6">
        <div>
          <h2 className="text-3xl font-bold text-[#111827]">Compose Message</h2>
          <div className="flex items-center text-sm text-gray-500 mt-1">
            <span>Home</span>
            <HiChevronRight className="mx-1 text-gray-400" />
            <span className="text-[#25D366] font-medium">Compose Message</span>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="mb-6 flex gap-3 flex-wrap">
        {tabs.map((tab) => (
          <button
            key={tab}
            onClick={() => {
              setActiveTab(tab);
              document.activeElement.blur(); 
            }}
            className={`px-5 py-2 rounded-full text-sm font-medium transition-all shadow-sm ${
              activeTab === tab
                ? "bg-[#25D366] text-white shadow-md"
                : "bg-white text-gray-700 hover:bg-gray-100 border border-gray-200"
            }`}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Active Component */}
      <div className="mt-4">
        {activeTab === "Single MSG" && <SingleMsg />}
        {activeTab === "Group" && <GroupMsg />}
        {activeTab === "CSV" && <CSVMsg />}
      </div>
    </div>
  );
}
